import React from "react";
import Loading from "../components/Loading";

const withFetchErrorHandler = (Component) => {
  const NewComponent = ({ articles, message, owner }) => {
    if (articles === undefined || articles === null) {
      return (
        <div className="articles-container">
          <Loading />
        </div>
      );
    } else if (articles?.length === 0) {
      return (
        <div className="articles-container ">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              height: "90vh",
              position: "absolute",

              width: "100%",
            }}
          >
            <a href="/article/publish">
              {" "}
              <h2>{message}</h2>{" "}
            </a>
          </div>
        </div>
      );
    }
    return <Component articles={articles} owner={owner} />;
  };
  return NewComponent;
};

export default withFetchErrorHandler;
